import { Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Container, IconWrapper } from './EmptyState.styled'
import { ReactNode } from 'react'

type EmptyStateTypes = {
  text?: string
  title?: string
  description?: string
  icon?: ReactNode
}

export const EmptyState = ({
  title = 'No content found',
  description,
  icon = <InfoOutlinedIcon fontSize="large" />,
}: EmptyStateTypes) => (
  <Container>
    {icon && <IconWrapper>{icon}</IconWrapper>}
    <Typography variant="body1" className="empty-state-text">
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" className="empty-state-description">
        {description}
      </Typography>
    )}
  </Container>
)
